import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Navbar from "./StockKeeperNavbar";
import InventoryOverview from "./InventoryOverview";
import Inventory from "../Inventory/InventoryList";
import ProductList from "../Product/ProductList";
import InventoryIssue from "./InventoryIssue";
import InventoryStats from "./InventoryStats";
import Popup from "../../components/ui/Popup";
import NavbarM from "../../components/Navbar";
import LowStockItems from "./LowStockItems";
function StockKeeperDashboard() {
    const [currentPage, setCurrentPage] = useState("Dashboard");
    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "success"
    });

    // Function to show popup
    const showPopup = (message, type = "success") => {
        setPopup({
            show: true,
            message,
            type
        });
    };

    // Function to close popup
    const closePopup = () => {
        setPopup({
            ...popup,
            show: false
        });
    };

    return (
        <Section>
            {/*<NavbarM className="navbar" pageTitle={currentPage} />*/}

            <Navbar className="navbar" pageTitle={currentPage} onNavigate={setCurrentPage} />

            <div className="content">
                {currentPage === "Dashboard" && (
                    <DashboardContent>
                        <div className="main-content">
                            <InventoryStats />
                            <LowStockItems showPopup={showPopup} />
                        </div>
                        <div className="side-content">
                            <InventoryOverview showPopup={showPopup} />
                        </div>
                    </DashboardContent>
                )}
                {currentPage === "InventoryIssue" && <InventoryIssue />}
                {currentPage === "Inventory" && <Inventory />}
                {currentPage === "Products" && <ProductList />}

                {/* Default view if no specific page is selected */}
                {/*{!["Dashboard","Inventory", "Products"].includes(currentPage) && <Inventory />}*/}
            </div>

            {popup.show && (
                <Popup
                    message={popup.message}
                    type={popup.type}
                    onClose={closePopup}
                    autoClose={true}
                    duration={4000}
                />
            )}
        </Section>
    );
}

export default StockKeeperDashboard;

const Section = styled.section`
    display: flex;
    flex-direction: column;
    margin-left: 18vw; /* Keeps space for the navbar */
    height: 100%;
    background-color: #f9f9f9;
    padding-top: 20px; /* Add padding instead of margin for better behavior */

    .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 20px;
    }

    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        width: 18vw;
        height: 100vh;
        background: black;
        color: white;
        padding: 20px;
        z-index: 2000;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }
`;

const DashboardContent = styled.div`
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 80px;
    margin-top: 200px; /* Reduced from 60px to prevent excessive spacing */
    width: 100%;

    .main-content {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .side-content {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
    }
`;